module.exports = __webpack_public_path__ + "er.svg?b4ea80f7a2a8848ad55e31b9bf3afc90";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/er.svg
// module id = 1087
// module chunks = 0